import { render, staticRenderFns } from "./IndicatorUpload.vue?vue&type=template&id=bca3fbee&scoped=true&"
import script from "./IndicatorUpload.vue?vue&type=script&lang=js&"
export * from "./IndicatorUpload.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorUpload.vue?vue&type=style&index=0&id=bca3fbee&lang=stylus&scoped=true&"
import style1 from "./IndicatorUpload.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./IndicatorUpload.vue?vue&type=style&index=2&id=bca3fbee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca3fbee",
  null
  
)

export default component.exports